interface Props {
    className?: string;
}

export function ChevronRightIcon({ className }: Props) {
    return (
        <svg className={className} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.4685 6.65548L4.30527 1.84162C4.28917 1.82894 4.26981 1.82106 4.24943 1.81888C4.22905 1.81671 4.20847 1.82033 4.19005 1.82932C4.17164 1.83832 4.15613 1.85232 4.14531 1.86973C4.1345 1.88714 4.12881 1.90725 4.12891 1.92775V2.98459C4.12891 3.05158 4.16035 3.11584 4.21231 3.15685L9.13417 7.00002L4.21231 10.8432C4.15899 10.8842 4.12891 10.9485 4.12891 11.0154V12.0723C4.12891 12.1639 4.23418 12.2145 4.30527 12.1584L10.4685 7.34455C10.5209 7.30369 10.5633 7.25142 10.5924 7.19172C10.6216 7.13201 10.6367 7.06645 10.6367 7.00002C10.6367 6.93358 10.6216 6.86802 10.5924 6.80832C10.5633 6.74862 10.5209 6.69635 10.4685 6.65548Z"
                fill="currentColor"
            />
        </svg>
    );
}
